<template>
    <div>
        <div class="container-fluid gray">
            <div class="container">
                <Page-Header />
            </div>
        </div>

        <!-- Progress Bar -->
        <div class="container-fluid r_dg_fa hidden-print">
            <Cart-Progress-Bar />
        </div>

        <modal id="sExpire-vue" v-if="showSessionExpireModal" @close="closeSessionExpireModal" size="xs">
            <template v-slot:header>
                <span class="ui-dialog-title">{{ labels[1124] }}</span><!-- label: Session Expired -->
            </template>

            <template v-slot:body>
                <h3>{{ labels[1125] }}</h3><!-- label: Your Session Has Expired -->
                <p>{{ sessionExpiredMsg }}</p>
            </template>

            <template v-slot:footer>
                <div class="ui-dialog-buttonpane ui-widget-content ui-helper-clearfix">
                    <div class="ui-dialog-buttonset">
                        <button type="button" @click="closeSessionExpireModal(false)" class="ui-button ui-widget ui-state-default ui-corner-all ui-button-text-only" role="button">
                            <span class="ui-button-text">{{ labels[1034] }}</span><!-- label: OK -->
                        </button>
                    </div>
                </div>
            </template>
        </modal>
    </div>
</template>

<script>
import { ref, computed, watch } from '@vue/composition-api'
import Modal from '../../shared/components/Modal.vue'
import useCMS from "../../shared/composables/useCMS"
import useCheckout from "../composables/useCheckout"
import PageHeader from '../components/PageHeader.vue'
import CartProgressBar from '../components/CartProgressBar.vue'
import useSessionKeeper from "../composables/useSessionKeeper"

export default {
    name: 'Checkout',
    components: {
        PageHeader,
        CartProgressBar,
        Modal
    },
    setup () {
        const { labels } = useCMS();
        const { sessionExpiredMsg, getErrorCodeMsgs } = useErrorCodeMsgs();
        const { showSessionExpireModal, closeSessionExpireModal } = useSessionKeeper();

        watch(showSessionExpireModal,(newVal) => {
            if(newVal){
                getErrorCodeMsgs()
            }
        });

        return {
            labels,
            showSessionExpireModal,
            closeSessionExpireModal,
            sessionExpiredMsg
        }
    }
}

function useErrorCodeMsgs () {
    const { info: checkoutInfo, getMsgFromEcode } = useCheckout();

    let sessionExpiredMsgRef = ref('');

    const sessionExpiredMsg = computed(() => sessionExpiredMsgRef.value);

    const getErrorCodeMsgs = () => {
        if (checkoutInfo.value.isQuote) {
            sessionExpiredMsgRef.value = 'Your session has expired due to inactivity. You will be taken back to your quote where you can begin the checkout process again. We apologize for the inconvenience.';
        } else {
            //code 16: Your session has expired due to inactivity. You will be taken back to your shopping cart where you can begin the checkout process again. We apologize for the inconvenience.
            getMsgFromEcode(16).then((resp) => {
                if (resp.status == 200) {
                    sessionExpiredMsgRef.value = resp.data;
                }
            }).catch((error) => {
                sessionExpiredMsgRef.value = 'Your session has expired due to inactivity.';
                console.log(error);
            });
        }
    }

    return {
        getErrorCodeMsgs,
        sessionExpiredMsg
    }
}
</script>
